<template>
  <div>
    <div
      :class="{'filter-header-show': isAutoShow}"
      class="filter-header"
    >
      <i
        v-if="isAutoShow"
        class="fa fa-filter"
      />
      Filter
    </div>

    <div
      id="filter-body"
      :class="{'filter-body-show': isAutoShow}"
    >
      <div v-if="filters.length > 0">
        <b-form-group
          v-for="(filter, index) in filters"
          :key="`${filter.field_data_key}-${index}`"
          class="mb-2"
        >
          <label>{{ filter.name }}</label>

          <j-input
            v-if="filter.type === 'text' || filter.type === 'number'"
            :error-required="false"
          />

          <div
            v-else-if="filter.type === 'date'"
            class="d-flex"
          >
            <j-input
              :error-required="false"
              placeholder="Start Date"
              class="mr-2"
            />
            <j-input
              :error-required="false"
              placeholder="End Date"
            />
          </div>

          <j-single-select
            v-else
            :error-required="false"
          />
        </b-form-group>
      </div>

      <!-- Default Filter -->
      <div v-else>
        <b-form-group>
          <label>Filter By</label>
          <j-single-select
            :error-required="false"
          />
        </b-form-group>

        <b-form-group class="m__t--10">
          <label>Value</label>
          <j-input
            :error-required="false"
          />
        </b-form-group>
      </div>
    </div>

    <div
      :class="{'filter-button-show': isAutoShow}"
      class="filter-button"
    >
      <button
        class="btn-gray"
        disabled>
        Reset
      </button>
      <button
        class="btn-blue"
        disabled>
        Filter
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    isAutoShow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .filter-header {
    width: 360px;
    height: 35px;
    background-color: #f1f1f1;
    margin: -8px -12px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-align: center;
    font-family: 'Poppins-Semibold';
    font-size: 12px;
    color: #8a8a8a;
    padding-top: 8px;
  }

  .filter-header-show {
    width: 300px;
    height: 35px;
    background-color: #FFFFFF;
    margin: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    text-align: left;
    color: #808285;
  }

  #filter-body {
    margin-top: 15px;
    margin-right: -8px;
    padding-right: 8px;
    max-height: 250px;
    overflow-x: hidden;

    label {
      font-family: 'Poppins-Regular';
      font-size: 12px;
      color: #353535;
    }
  }
  .filter-body-show {
    margin-top: 0 !important;
    margin-right: 0 !important;
    padding-right: 0 !important;
    max-height: unset !important;
    overflow-x: unset !important;
    width: 300px;
  }

  .filter-button {
    display: flex;
    align-items: center;
    margin-top: 8px;
    padding-top: 8px;

    .btn-gray {
      padding: 7px 25px;
      font-family: 'Poppins-Semibold';
      font-size: 12px;
      background: #f2f2f2;
      color: #606060;
      box-shadow: none;
      border: none;
      border-radius: 6px;
      margin-right: 5px;
      &:focus {
        outline: none;
      }
      &:disabled {
        opacity: 0.6;
      }
    }
    .btn-blue {
      width: 100%;
      padding: 7px 25px;
      font-family: 'Poppins-Semibold';
      font-size: 12px;
      background: #1A85E4;
      color: #FFFFFF;
      box-shadow: none;
      border: none;
      border-radius: 6px;
      &:focus {
        outline: none;
      }
      &:disabled {
        opacity: 0.6;
      }
    }
  }

  .filter-button-show {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/PopupFilter.vue